export enum CaptureValueType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  INTEGER = 'integer',
  JSON = 'json',
  CONTAINER = 'container',
}

export enum CaptureLevel0Types {
  /** Core Functionality */
  CORE_FUNCTIONALITY_CUSTOMER_FACING_DISPLAY = 'core_functionality_customer_facing_display',
  CORE_FUNCTIONALITY_CUSTOMER_CONNECT = 'core_functionality_customer_connect',
  CORE_FUNCTIONALITY_PAYMENT_ORCHESTRATION = 'core_functionality_payment_orchestration',
  CORE_FUNCTIONALITY_STORED_VALUE_ISSUING = 'core_functionality_stored_value_issuing',
  CORE_FUNCTIONALITY_CALL_TO_ACTION = 'core_functionality_call_to_action',
  CORE_FUNCTIONALITY_DIGITAL_RECEIPT = 'core_functionality_digital_receipt',


  /** Payment Options */
  PAYMENT_OPTIONS_CASH = 'payment_options_cash',
  PAYMENT_OPTIONS_GIFT_CARD = 'payment_options_gift_card',
  PAYMENT_OPTIONS_OWN_LABELED_CARD = 'payment_options_own_labeled_card',
  PAYMENT_OPTIONS_VALUE_TOKEN = 'payment_options_stored_value_token',
  PAYMENT_OPTIONS_LOYALTY = 'payment_options_loyalty',
  PAYMENT_OPTIONS_DIGITAL_WALLETS = 'payment_options_digital_wallets',
  PAYMENT_OPTIONS_BUY_NOW_PAY_LATER = 'payment_options_buy_now_pay_later',
  PAYMENT_OPTIONS_ACCOUNT_TO_ACCOUNT_PAYMENTS = 'payment_options_account_to_account_payments',
  PAYMENT_OPTIONS_LENDING_SYSTEM = 'payment_options_lending_system',
  PAYMENT_OPTIONS_CRYPTO_COIN = 'payment_options_crypto_coin',
  PAYMENT_OPTIONS_PAYMENT_LINK = 'payment_options_payment_link',
  PAYMENT_OPTIONS_STORE_CREDIT = 'payment_options_store_credit',
  PAYMENT_OPTIONS_STOCK_PORT_WALLET = 'payment_options_stock_port_wallet',
  PAYMENT_OPTIONS_PAY_AI = 'payment_options_pay_ai',
  PAYMENT_OPTIONS_VISA_MASTERCARD = 'payment_options_visa_mastercard',


/** Value Added Services */
  VALUE_ADDED_SERVICES_DYNAMIC_CURRENCY_CONVERSION = 'value_added_services_dynamic_currency_conversion',
  VALUE_ADDED_SERVICES_GAMIFICATION = 'value_added_services_gamification',
  VALUE_ADDED_SERVICES_PROMOTE = 'value_added_services_promote',
  VALUE_ADDED_SERVICES_SPLIT_X_TYPE = 'value_added_services_split_x_type',
  VALUE_ADDED_SERVICES_SPLIT_PAYMENT = 'value_added_services_split_payment',
  VALUE_ADDED_SERVICES_MEMBERSHIP_LOYALTY = 'value_added_services_membership_loyalty',
  VALUE_ADDED_SERVICES_TIPPING = 'value_added_services_tipping',
  VALUE_ADDED_SERVICES_TAX_BACK = 'value_added_services_tax_back',
  VALUE_ADDED_SERVICES_TICKET_ISSUING = 'value_added_services_ticket_issuing'

}

export enum CaptureLevel1Types {

  /** Customer-Facing Display */
  GENERAL_SETTINGS = 'general_settings',
  WELCOME_SCREEN = 'welcome_screen',
  SHOPPING_BASKET = 'shopping_basket',
  CHECKOUT = 'checkout',
  THANK_YOU_SCREEN = 'thank_you_screen',

  /** Customer Connect */
  LOYALTY_MEMBERSHIP = 'loyalty_membership',
  LIVE_BASKET = 'customer_device_live_basket',
  PERSONALISATION = 'personalisation',

  /** Stored Value Issuing */
  GIFT_CARDS = 'gift_cards',
  DIGITAL_WALLETS = 'digital_wallets',

  /** Promotion */
  WELCOME_SCREEN_PROMOTION = 'welcome_screen_promotion',
  CHECKOUT_PROMOTION = 'checkout_promotion',

  /** Digital Receipt */
  DIGITAL_RECEIPT = 'digital_receipt',
  ORDER_REFERENCE = 'order_reference',
  SALES_PERSON_DETAILS = 'sales_person_details',
  CUSTOMER_ENGAGEMENT = 'customer_engagement',
  DONATION = 'donation',
  LEAVE_REVIEW = 'leave_review',
  MERCHANT_FOOTER = 'merchant_footer'
}

/** Payment Orchestration */

export enum PaymentOrchestrationTypes {
  PRIMARY_PAYMENT_SERVICE_PROVIDER = 'primary_payment_service_provider',
  USE_PRIMARY_PAYMENT_SERVICE_PROVIDER = 'use_primary_payment_service_provider',
  AUTO_DEFINE_PAYMENT_SERVICE_PROVIDER = 'auto_define_payment_service_providers',
  CUSTOM_PAYMENT_SERVICE_PROVIDER = 'custom_payment_service_providers',
}

// level 2

export enum GeneralSettingsTypes {
  GENERAL_INFORMATION = 'general_information',
  MULTI_LANGUAGE_SUPPORT = 'multi_language_support',
  TILL_DATA_CONNECTION = 'till_data_connection',
  CRM_SYSTEM_CONNECTION = 'crm_system_connection',
}

export enum WelcomeScreenTypes {
  WELCOME_SCREEN_MESSAGE = 'welcome_screen_message',
  WELCOME_SCREEN_PROMOTION = 'welcome_screen_promotion',
}

export enum GiftCardsTypes {
  GIFT_CARDS_ISSUING = 'gift_cards_issuing',
}

export enum DigitalWalletTypes {
  DIGITAL_WALLET_ISSUING = 'digital_wallet_issuing',
}

export enum PaymentServiceProvidersTypes {
  PRIMARY_PAYMENT_SERVICE_PROVIDER = 'primary_payment_service_provider',
  AUTO_DEFINE_PAYMENT_SERVICE_PROVIDER = 'auto_define_payment_service_providers',
  CUSTOM_PAYMENT_SERVICE_PROVIDER = 'custom_payment_service_providers',
}

export enum DynamicCurrencyConversionL2Type {
  ADYEN = 'adyen',
  EURONET_WORLDWIDE = 'euronet_worldwide',
  EVALON = 'evalon',
  FEXCO = 'fexco',
  GLOBAL_BLUE = 'global_blue',
  PLANET = 'planet',
  TRAVELEX = 'travelex',
  WORLDPAY = 'worldpay',
}

export enum GamificationL2Type {
  DRAFT_KINGS = 'draft_kings',
  FLUUK = 'fluuk',
  BET365 = 'bet365',
  CAESARS_ENTERTAINMENT = 'caesars_entertainment',
  FLUTTER = 'flutter',
  EVOKE = 'evoke',
  EVOLUTION = 'evolution',
  ENTAIN = 'entain',
}

export enum TippingL2Type {
  TIPPING_STRIKEPAY = 'tipping_strikepay',
  TIPPING_ETIP = 'tipping_etip',
  TIPPING_JUSTTIP = 'tipping_justtip',
  TIPPING_GLOBALTIPS = 'tipping_globaltips',
  TIPPING_TIPALTI = 'tipping_tipalti',
}

export enum TaxBackL2Type {
  TAX_BACK_GLOBALBLUE = 'tax_back_globalblue',
  TAX_BACK_PLANET = 'tax_back_planet',
  TAX_BACK_TAXFREE_EPAY = 'tax_back_taxfree_epay',
  TAX_BACK_TAXFREE_WORLDWIDE = 'tax_back_taxfree_worldwide',
}

export enum TicketIssuingL2Type {
  TICKET_ISSUING_LIVE_NATION = 'ticket_issuing_live_nation',
  TICKET_ISSUING_AXS = 'ticket_issuing_axs',
  TICKET_ISSUING_VIVIDSEATS = 'ticket_issuing_vividseats',
  TICKET_ISSUING_STUBHUB = 'ticket_issuing_stubhub',
  TICKET_ISSUING_EVENTIM = 'ticket_issuing_eventim',
}

export enum PaymentOptionsOtherPaymentTypes {
  CASH = 'cash'
}

export enum PaymentOptionsGiftCardTypes {
  IN_COM_PAYMENTS = 'in_comm_payments',
  SVS = 'svs',
  BLACKHAWK = 'blackhawk',
  FISERV = 'fiserv',
  GIVEX = 'givex',
  EDENRED = 'edenred',
  SAVVY = 'savvy',
  CRAVE_CARDS = 'crave_cards',
}

export enum PaymentOptionsOwnLabeledCardTypes {
  OWN_LABELED_CARD = 'own_labeled_card'
}

export enum PaymentOptionsStoredValueTokenTypes {
  FISERV = 'stored_value_token_fiserv',
  WORLDPAY = 'stored_value_token_worldpay',
  SHIFT_4 = 'stored_value_token_shift4',
  ADYEN = 'stored_value_token_adyen',
}

export enum PaymentOptionsLoyaltyTypes {
  YOTPO = 'loyalty_yotpo',
  ANNEX_CLOUD = 'loyalty_annex_cloud',
  SMILE_IO = 'loyalty_smile_io',
  LOYALTY_LION = 'loyalty_loyalty_lion',
  CLUTCH = 'loyalty_clutch_fis',
  PUNCHH = 'loyalty_punchh',
}

export enum PaymentOptionsDigitalWalletTypes {
  APPLE_PAY = 'digital_wallets_apple_pay',
  GOOGLE_PAY = 'digital_wallets_google_pay',
  PAY_PAL = 'digital_wallets_pay_pal',
  REVOLUT = 'digital_wallets_revolut',
  SAMSUNG_PAY = 'digital_wallets_samsung_pay',
}

export enum PaymentOptionsBuyNowPayLaterTypes {
  KLARNA = 'buy_now_pay_later_klarna',
  AFTERPAY = 'buy_now_pay_later_afterpay',
  AFFIRM = 'buy_now_pay_later_affirm',
  SEZZLE = 'buy_now_pay_later_sezzle',
  ZIP = 'buy_now_pay_later_zip',
}

export enum PaymentOptionsAccountToAccountTypes {
  PLAID = 'account_to_account_payments_plaid',
  DWOLLA = 'account_to_account_payments_dwolla',
  STRIPE = 'account_to_account_payments_stripe',
  GO_CARDLESS = 'account_to_account_payments_go_cardless'
}

export enum PaymentOptionsLendingSystemTypes {
  AFFIRM = 'lending_system_affirm',
  GREEN_SKY = 'lending_system_green_sky',
  BREAD = 'lending_system_bread',
  PAY_PAL = 'lending_system_pay_pal'
}

export enum PaymentOptionsCryptoCoinTypes {
  BIT_PAY = 'crypto_coin_bit_pay',
  COINBASE = 'crypto_coin_coinbase_commerce',
  STRIKE = 'crypto_coin_strike',
}

export enum PaymentOptionsPaymentLinkTypes {
  STRIPE = 'payment_link_stripe',
  PAY_PAL = 'payment_link_pay_pal',
  ADYEN = 'payment_link_adyen',
  BRAINTREE = 'payment_link_braintree',
}

export enum PaymentOptionsStoreCreditTypes {
  RISE_AI = 'store_credit_rise_ai',
  GIFT_UP = 'store_credit_gift_up',
  LOOP_RETURNS = 'store_credit_loop_returns',
  RETURNLY = 'store_credit_returnly',
}

export enum PaymentOptionsStockPortWalletTypes {
  BITS_OF_STOCK = 'stock_port_wallet_bits_of_stock',
  BUMPED = 'stock_port_wallet_bumped',
}

export enum PaymentOptionsPayAiTypes {
  PAY_AI = 'pay_ai',
}

export enum PaymentOptionsVisaMastercardTypes {
  VISA = 'payment_options_visa',
  MASTERCARD = 'payment_options_mastercard',
  AMERICAN_EXPRESS = 'payment_options_american_express',
  DISCOVER = 'payment_options_discover',
}

//level 3

export enum GiftCardsIssuingTypes {
  GIFT_CARD_INTEGRATION_PROVIDER = 'gift_cards_integration_provider',
}

export enum DigitalWalletIssuingTypes {
  DIGITAL_WALLET_INTEGRATION_PROVIDER = 'digital_wallet_integration_provider',
}

export enum ShoppingBasketTypes {
  TILL_DATA_CONNECTION = 'till_data_connection',
  BASKET_DATA_MAPPING = 'basket_data_mapping',
  ADD_LOYALTY_BUTTON = 'add_loyalty_button',
  ADD_GIFTCARD_BUTTON = 'add_giftcard_button',
}

export enum WelcomeScreenMessageTypes {
  WELCOME_MESSAGE = 'welcome_message',
  SHOW_MERCHANT_LOGO = 'show_merchant_logo',
  SHOW_SCREEN_BACKGROUND = 'screen_background',
  WELCOME_MESSAGE_DISPLAY_TIME = 'welcome_message_display_time',
}

export enum WelcomeScreenLevel4Types {
  MERCHANT_LOGO_URL = 'merchant_logo_url'
}

export enum WelcomeScreenPromotionTypes {
  WELCOME_SCREEN_PROMOTION_MEDIA_URL = 'welcome_screen_promotion_media_url',
}

export enum AutoDefinePaymentServiceProvidersTypes {
  MAXIMISE_FOR = 'maximise_for',
  AUTO_RECALCULATE_BEST_PSP_FREQUENCY = 'automatically_recalculate_best_psp_frequency',
}


// level 4

export enum ScreenBackgroundTypes {
  BACKGROUND_COLOR = 'background_color',
  BACKGROUND_IMAGE = 'background_image',
}

export enum CheckoutTypes {
  TILL_DATA_CONNECTION = 'till_data_connection',
  CHECKOUT_DATA_MAPPING = 'checkout_data_mapping',
  ALLOW_SPLIT_PAYMENT = 'allow_split_payment',
}

export enum ThankYouScreenTypes {
  TRANSACTION_MESSAGE = 'transaction_message',
  TRANSACTION_SUCCESS_MESSAGE = 'transaction_success_message',
  TRANSACTION_FAILED_MESSAGE = 'transaction_failed_message',
  AUTO_CLEAR_SCREEN = 'auto_clear_screen',
  TRANSACTION_COMPLETED_AUTO_CLEAR_SCREEN_TIME = 'transaction_completed_auto_clear_screen_time'
}

export enum LoyaltyMembershipTypes {
  LOYALTY = 'loyalty',
  LOYALTY_INTEGRATION_PROVIDER = 'loyalty_integration_provider',
  MEMBERSHIP = 'membership',
  MEMBERSHIP_INTEGRATION_PROVIDER = 'membership_integration_provider'
}

export enum LiveBasketTypes {
  BUSINESS_DETAILS = 'business_details',
  LIVE_BASKET_DATA_MAPPING = 'live_basket_data_mapping',
  SESSION_TIMEOUT = 'session_timeout'
}

export enum LiveBasket_BusinessDetailsTypes {
  SHOW_CURRENT_DATE = "live_basket_show_current_date",
  SHOW_CURRENT_TIME = "live_basket_show_current_time",
  SHOW_MERCHANT_ADDRESS = "live_basket_show_merchant_address",
  SHOW_MERCHANT_NAME = "live_basket_show_merchant_name",
  SHOW_SALES_PERSON_DETAILS = "live_basket_show_sales_person_details",
  SHOW_TILL_NUMBER = "live_basket_show_till_number",
  SHOW_BACKGROUND = "show_background",
  SHOW_LOGO = "show_logo",
  SHOW_MERCHANT_TAX_ID_VAT = "show_merchant_tax_id_vat",
  SHOW_SALES_PERSON = "show_sales_person",
  SHOW_WEBSITE = "live_basket_show_website",
}

export enum LiveBasket_DataMappingTypes {
  PRODUCT_NAME = "product_name",
  PRODUCT_QUANTITY = "product_quantity",
  UNIT_PRICE = "live_basket_unit_price",
  SUBTOTAL_TOTAL = "live_basket_subtotal_total",
  TAX = "live_basket_tax",
  DISCOUNTS_PROMOTIONS = "live_basket_discounts_promotions",
  ORDER_REFERENCE = "live_basket_order_reference"
}

export enum LiveBasket_ColorBackgroundTypes {
  BACKGROUND_COLOR = "live_basket_background_color",
  BACKGROUND_IMAGE_URL = "logo_url"
}

export enum LiveBaskedSessionTimeoutTypes {
  AMOUNT = 'amount',
  TIME_UNIT = 'time_unit'
}

export enum DigitalReceiptTypes {
  DIGITAL_RECEIPT_BUSINESS_DETAILS = 'digital_receipt_business_details',
  TRANSACTION_DETAILS = 'transaction_details',
  PAYMENT_METHOD = 'payment_method',
  ITEMISED_PURCHASE_LIST = 'itemised_purchase_list',
  SHOW_SALES_PERSON_NAME_ID = 'show_sales_person_name_id',
  SHOW_LOYALTY_MEMBERSHIP_DETAILS = 'show_loyalty_membership_details',
  SHOW_RETURNS_REFUND_POLICY_STATEMENT = 'show_returns_refund_policy_statement',
}

export enum DigitalReceipt_BusinessDetailsTypes {
  SHOW_BUSINESS_NAME = 'show_business_name',
  SHOW_BUSINESS_ADDRESS = 'show_business_address',
  SHOW_CONTACT_PHONE = 'show_contact_phone',
  SHOW_CONTACT_EMAIL = 'show_contact_email',
  SHOW_TAX_ID_VAT = 'show_tax_id_vat',
}

export enum DigitalReceipt_TransactionDetailsTypes {
  SHOW_DATE_OF_PURCHASE = 'show_date_of_purchase',
  SHOW_TIME_OF_PURCHASE = 'show_time_of_purchase',
  SHOW_RECEIPT_NUMBER = 'show_receipt_number',
  SHOW_TRANSACTION_NUMBER = 'show_transaction_number',
  SHOW_TRANSACTION_SOURCE = 'show_transaction_source',
  SHOW_MERCHANT_ID = 'show_merchant_identification_number',
  SHOW_TERMINAL_ID = 'show_terminal_identification_number',
}

export enum DigitalReceipt_PaymentMethodTypes {
  SHOW_PAYMENT_METHOD = 'show_payment_method',
  SHOW_LAST4_CARD = 'show_last_4_digits_of_card',
}

export enum DigitalReceipt_ItemisedPurchaseListTypes {
  SHOW_DESCRIPTION = 'show_description_of_each_product_service',
  SHOW_QUANTITY = 'show_quantity',
  SHOW_UNIT_PRICE = 'show_unit_price',
  SHOW_TOTAL_PER_LINE_ITEM = 'show_total_per_line_item',
  SHOW_SUBTOTAL_BEFORE_TAX = 'show_subtotal_before_tax',
  SHOW_TAXES_WITH_RATE = 'show_taxes_with_percentage_rate',
  SHOW_DISCOUNTS = 'show_discounts',
  SHOW_FINAL_AMOUNT_PAYABLE = 'show_final_total_amount_payable',
}

export enum OrderReferenceTypes {
  ORDER_NUMBERS = 'order_numbers',
  HUMAN_FRIENDLY_ORDER_REFERENCE = 'human_friendly_order_reference',
}

export enum LeaveReviewTypes {
  NET_PROMOTER_SCORE = 'net_promoter_score',
  CUSTOMER_SATISFACTION = 'customer_satisfaction',
}

export enum MerchantFooterDetailsTypes {
  SHOW_MERCHANT_LOGO = 'digital_receipt_show_merchant_logo',
  SHOW_MERCHANT_NAME = 'digital_receipt_show_merchant_name',
  SHOW_MERCHANT_ADDRESS = 'digital_receipt_show_merchant_address',
  SHOW_MERCHANT_CONTACT_PHONE = 'digital_receipt_show_merchant_contact_phone',
  SHOW_MERCHANT_CONTACT_EMAIL = 'digital_receipt_show_merchant_contact_email',
  SHOW_MERCHANT_WEBSITE = 'digital_receipt_show_merchant_website',
  SHOW_MERCHANT_SOCIAL_MEDIA_LINKS = 'digital_receipt_show_merchant_social_media_links',
}

export enum SalesPersonDetailsTypes {
  HR_SUITE_PROVIDER = 'hr_suite_provider',
  DEFAULT_SALES_PERSON_IMAGE = 'default_sales_person_image',
  DEFAULT_SALES_PERSON_MESSAGE = 'default_sales_person_message',
  ALLOW_IMAGE_FROM_EMPLOYEE_PROFILE = 'allow_image_from_employee_profile',
  ALLOW_MESSAGE_FROM_EMPLOYEE_PROFILE = 'allow_message_from_employee_profile',
  SHOW_SALES_PERSON_RATING = 'show_sales_person_rating',
  SALES_PERSON_DETAILS_LEAVE_TIP = 'sales_person_details_leave_tip',
}

export enum CustomerEngagementTypes {
  CUSTOMER_REGISTRATION = 'customer_registration',
  ADD_INCENTIVE_TO_REGISTER = 'add_incentive_to_register',
  REGISTER_INCENTIVE = 'register_incentive',
  LOYALTY_PROGRAMME = 'loyalty_programme',
  ADD_INCENTIVE_TO_JOIN_LOYALTY = 'add_incentive_to_join_loyalty',
  LOYALTY_INCENTIVE = 'loyalty_incentive',
  GIFT_CARD_UPSELL = 'gift_card_upsell',
  DOWNLOAD_APP = 'download_app',
}

export enum DonationTypes {
  CHARITY_PARTNER = 'charity_partner',
}
// JSON types

export enum CRMSystemConnectionSettingsTypes {
  CRM_PROVIDER = 'crmProvider',
  API_KEY = 'apiKey',
}

export enum CRMSystemConnectionSettingsLabels {
  CRM_PROVIDER = 'CRM Provider',
  API_KEY = 'API Key',
}

export enum TillDataConnectionSettingsTypes {
  SALES_SYSTEM_URL = 'salesSystemUrl',
  API_KEY = 'apiKey',
}

export enum TillDataConnectionSettingsLabels {
  SALES_SYSTEM_URL = 'Sales System URL',
  API_KEY = 'API Key',
}

export enum WelcomeScreenPromotionMediaUrlTypes {
  MEDIA_URL = 'mediaUrl',
  MEDIA_DISPLAY_TIME = 'mediaDisplayTime',
}

export enum WelcomeScreenPromotionMediaUrlLabels {
  MEDIA_URL = 'Media URL',
  MEDIA_DISPLAY_TIME = 'Show promotion for',
}

export enum LoyaltyMembershipSettingsTypes {
  PROVIDER = 'provider',
}

export enum GiftCardsIntegrationProviderType {
  PROVIDER = 'provider',
}

export enum DigitalWalletIntegrationProviderType {
  PROVIDER = 'provider',
}


export enum DualPricingIntegrationProviderType {
  PROVIDER = 'provider',
}

export enum PrimaryServiceProviderType {
  CARD_TYPE = 'cardType',
  PAYMENT_PROVIDER_NAME = 'paymentProviderName',
  PAYMENT_PROVIDER_ID = 'paymentProviderId',
}

export enum OrchestratedServiceProviderType {
  CARD_TYPE = 'cardType',
  PAYMENT_PROVIDER_NAME = 'paymentProviderName',
  PAYMENT_PROVIDER_ID = 'paymentProviderId',
  RATE_PERCENTAGE = 'ratePercentage',
  RATE_USD = 'rateUsd',
}

export enum OrchestratedServiceProviderStrategyType {
  BEST_PRICE = 'best_price',
  FASTEST_SETTLEMENT = 'fastest_settlement'
}

export enum CallToActionValuesType {
  LOCATION = 'ctaLocation',
  BUTTON = 'ctaButton',
  TEXT = 'ctaText',
  OFFER = 'ctaOffer',
  TYPE = 'ctaOfferType',
  AMOUNT = 'ctaOfferAmount',
  LOYALTY_POINTS = 'ctaOfferLoyaltyPoints'
}

export enum DynamicCurrencyConversionApiKeyL3Type {
  FEXCO_API_KEY = 'fexco_api_key',
  PLANET_API_KEY = 'planet_api_key',
  GLOBAL_BLUE_API_KEY = 'global_blue_api_key',
  TRAVELEX_API_KEY = 'travelex_api_key',
  ADYEN_API_KEY = 'adyen_api_key',
  WORLDPAY_API_KEY = 'worldpay_api_key',
  EURONET_WORLDWIDE_API_KEY = 'euronet_worldwide_api_key',
  EVALON_API_KEY = 'evalon_api_key',
}

export enum GamificationApiKeyL3Type {
  DRAFT_KINGS_API_KEY = 'draft_kings_api_key',
  FLUUK_API_KEY = 'fluuk_api_key',
  CAESARS_ENTERTAINMENT_API_KEY = 'caesars_entertainment_api_key',
  BET365_API_KEY = 'bet365_api_key',
  FLUTTER_API_KEY = 'flutter_api_key',
  EVOKE_API_KEY = 'evoke_api_key',
  EVOLUTION_API_KEY = 'evolution_api_key',
  ENTAIN_API_KEY = 'entain_api_key',
}

export enum TippingApiKeyL3Type {
  TIPPING_STRIKEPAY_API_KEY = 'tipping_strikepay_api_key',
  TIPPING_ETIP_API_KEY = 'tipping_etip_api_key',
  TIPPING_JUSTTIP_API_KEY = 'tipping_justtip_api_key',
  TIPPING_GLOBALTIPS_API_KEY = 'tipping_globaltips_api_key',
  TIPPING_TIPALTI_API_KEY = 'tipping_tipalti_api_key',
}

export enum TaxBackApiKeyEnum {
  TAX_BACK_GLOBALBLUE_API_KEY = 'tax_back_globalblue_api_key',
  TAX_BACK_PLANET_API_KEY = 'tax_back_planet_api_key',
  TAX_BACK_TAXFREE_EPAY_API_KEY = 'tax_back_taxfree_epay_api_key',
  TAX_BACK_TAXFREE_WORLDWIDE_API_KEY = 'tax_back_taxfree_worldwide_api_key',
}

export enum TicketIssuingApiKeyEnum {
  TICKET_ISSUING_LIVE_NATION_API_KEY = 'ticket_issuing_live_nation_api_key',
  TICKET_ISSUING_AXS_API_KEY = 'ticket_issuing_axs_api_key',
  TICKET_ISSUING_VIVIDSEATS_API_KEY = 'ticket_issuing_vividseats_api_key',
  TICKET_ISSUING_STUBHUB_API_KEY = 'ticket_issuing_stubhub_api_key',
  TICKET_ISSUING_EVENTIM_API_KEY = 'ticket_issuing_eventim_api_key',
}


export enum PaymentOptionsCashL3Type {
  IS_DUAL_PRICE_ENABLED = 'is_dual_pricing_enabled'
}

export enum PaymentOptionsCashL4Type {
  CASH_DUAL_PRICING = 'cash_dual_pricing'
}
